import { Mapper } from './Mapper';

/**
 * @implements {import('./Mapper').Mapper}
 */
export class SimpleMapper extends Mapper {
    static Map = {};

    static toEntity(dto) {
        return Object.fromEntries(
            Object.entries(this.Map).map(([propName, dtoFieldName]) => [propName, dto[dtoFieldName]])
        );
    }

    static toDto(entity) {
        return Object.fromEntries(
            Object.entries(this.Map).map(([propName, dtoFieldName]) => [dtoFieldName, entity[propName]])
        );
    }
}
